import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import StationsPage from './pages/StationsPage';
import ContactPage from './pages/ContactPage';
import IndividualsPage from './pages/IndividualsPage';
import BusinessPage from './pages/BusinessPage';
import FleetPage from './pages/business/FleetPage';
import VenuePage from './pages/business/VenuePage';
import HospitalityPage from './pages/business/HospitalityPage';
import PublicPage from './pages/business/PublicPage';
// English Pages
import HomePageEN from './pages/en/HomePageEN';
import TermsPageEN from './pages/en/TermsPageEN';
import ContactPageEN from './pages/en/ContactPageEN';
import AboutPageEN from './pages/en/AboutPageEN';
import IndividualsPageEN from './pages/en/IndividualsPageEN';
import BusinessPageEN from './pages/en/BusinessPageEN';
import StationsPageEN from './pages/en/StationsPageEN';
import FleetPageEN from './pages/en/business/FleetPageEN';
import VenuePageEN from './pages/en/business/VenuePageEN';
import HospitalityPageEN from './pages/en/business/HospitalityPageEN';
import PublicPageEN from './pages/en/business/PublicPageEN';
// Terms & Privacy Pages
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import PrivacyPageEN from './pages/en/PrivacyPageEN';
// Delete Account Pages
import DeleteAccountPage from './pages/DeleteAccountPage';
import DeleteAccountEN from './pages/en/DeleteAccountEN';
// Blog & Gallery Pages
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import GalleryPage from './pages/GalleryPage';
// App Pages
import AppPage from './pages/AppPage';
import DownloadRedirect from './pages/DownloadRedirect';
// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

// Admin layout without header/footer
const AdminLayout = ({ children }) => (
  <main>{children}</main>
);

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes - No Header/Footer */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* Public Routes with Header/Footer */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  {/* Albanian Routes */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
                  <Route path="/stations" element={<StationsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/individuals" element={<IndividualsPage />} />
                  <Route path="/business" element={<BusinessPage />} />
                  <Route path="/biznese/flota" element={<FleetPage />} />
                  <Route path="/biznese/venue" element={<VenuePage />} />
                  <Route path="/biznese/mikpritje" element={<HospitalityPage />} />
                  <Route path="/biznese/publike" element={<PublicPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/delete-account" element={<DeleteAccountPage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/app" element={<AppPage />} />
                  <Route path="/download" element={<DownloadRedirect />} />
                  <Route path="/qr" element={<DownloadRedirect />} />
                  
                  {/* English Routes */}
                  <Route path="/en" element={<HomePageEN />} />
                  <Route path="/en/terms" element={<TermsPageEN />} />
                  <Route path="/en/privacy" element={<PrivacyPageEN />} />
                  <Route path="/en/about" element={<AboutPageEN />} />
                  <Route path="/en/services" element={<ServicesPage />} />
                  <Route path="/en/services/:serviceId" element={<ServiceDetailPage />} />
                  <Route path="/en/stations" element={<StationsPageEN />} />
                  <Route path="/en/contact" element={<ContactPageEN />} />
                  <Route path="/en/individuals" element={<IndividualsPageEN />} />
                  <Route path="/en/business" element={<BusinessPageEN />} />
                  <Route path="/en/business/fleet" element={<FleetPageEN />} />
                  <Route path="/en/business/venue" element={<VenuePageEN />} />
                  <Route path="/en/business/hospitality" element={<HospitalityPageEN />} />
                  <Route path="/en/business/public" element={<PublicPageEN />} />
                  <Route path="/en/delete-account" element={<DeleteAccountEN />} />
                  <Route path="/en/gallery" element={<GalleryPage />} />
                  <Route path="/en/blog" element={<BlogPage />} />
                  <Route path="/en/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/en/app" element={<AppPage />} />
                  <Route path="/en/download" element={<DownloadRedirect />} />
                  <Route path="/en/qr" element={<DownloadRedirect />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
